import "./hb-footer.module.css";
import { html } from "lit-html";

export default (user) => html`
    <hb-login></hb-login>
    <hb-signin></hb-signin>
    <hb-humanity></hb-humanity>
    <hb-phone></hb-phone>
    <hb-features></hb-features>
    <hb-about></hb-about>
    <hb-tabbar></hb-tabbar>
`;
